export enum CurrencyEnum {
    LB = 4,
    USD = 5
}